module.exports = __webpack_public_path__ + "static/DC4-4ab6a371881438889f10d1559d4fed6d.jpg";